import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  pricingToolContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '100%',
  },
  fieldWidth: {
    width: theme.spacing(37),
  },
  fieldRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    width: '100%',
  },
  applyButton: {
    alignSelf: 'flex-start',
  },
  successText: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
  },
  check: {
    color: '#00820D',
  },
  successTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}))
